import { useNavigate } from 'react-router-dom';

export default function useNavigation() {
  const navigate = useNavigate();

  return {
    browse: questionNumber => navigate(`/search/browse/questions/${questionNumber}`),
    navigateQuiz: (quizId, questionNumber, filter = 'questions') => navigate(`/quizzes/${quizId}/${filter}/${questionNumber}`),
    pause: () => navigate('/'),
    report: quizId => navigate(`/quizzes/${quizId}/report`)
  };
}
